import React from 'react';
import { C } from '../../theme.js';

// ── Free-typing decimal number input ────────────────────────────────────
// A plain `<input type="number" value={n} onChange={...parseFloat...}>`
// re-renders its own displayed value from the parsed number on every
// keystroke — so a partial value like "0." or "0.0" gets its trailing
// character silently stripped the instant it's typed (Number(0.0) -> "0"),
// making it impossible to type a fresh decimal like 0.07. This keeps its
// own draft text state and only re-syncs from `value` when they've
// genuinely diverged (e.g. a preset button changed it externally), never
// while the two already agree numerically — so an in-progress "0." isn't
// clobbered just because it currently parses to the same 0 as `value`.
export function PValueInput({ value, onChange, step = '0.01', min = '0', max = '1', style }) {
  const [text, setText] = React.useState(String(value));

  React.useEffect(() => {
    setText(prev => {
      const n = parseFloat(prev);
      return n === value ? prev : String(value);
    });
  }, [value]);

  return (
    <input
      type="number"
      step={step}
      min={min}
      max={max}
      value={text}
      onChange={(e) => {
        const raw = e.target.value;
        setText(raw);
        const n = parseFloat(raw);
        if (!isNaN(n)) onChange(n);
      }}
      style={{
        width: 120, background: C.input, color: C.fg1,
        border: `1px solid ${C.borderStrong}`, borderRadius: 6,
        padding: '6px 9px', fontSize: '.82rem', outline: 'none',
        fontFamily: 'inherit',
        ...style,
      }}
    />
  );
}
